const words = [
  "WEBSITES",
  "LOCAL BUSINESS",
  "SEO",
  "BRANDING",
  "MOBILE-FIRST",
  "OAKLAND",
];

const TickerContent = () => (
  <>
    {words.map((word, i) => (
      <span
        key={i}
        className="font-heading text-2xl md:text-4xl uppercase tracking-tight mx-6 md:mx-10 flex-shrink-0"
      >
        <span className="text-[#FFFDF5]">{word}</span>
        <span className="text-[#FE4A90] ml-6 md:ml-10">/</span>
      </span>
    ))}
  </>
);

export default function MarqueeStrip() {
  return (
    <div
      data-testid="marquee-strip"
      className="section-divider border-b-[3px] border-[#0A0A0A] bg-[#0A0A0A] py-4 overflow-hidden"
    >
      <div className="marquee-track">
        <div className="marquee-inner">
          <TickerContent />
          <TickerContent />
          <TickerContent />
          <TickerContent />
        </div>
      </div>
    </div>
  );
}
